import { Feedback, User, UserRequest } from '@/models/User';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { Users, UserTypes } from './types';

export const getUsersRequest = (data: UserRequest) => action(UserTypes.GET_USERS_REQUEST, data);
export const getUsersSuccess = (data: Users, total: number) => action(UserTypes.GET_USERS_SUCCESS, { data, total });
export const getUsersFailure = (error: AxiosError) => action(UserTypes.GET_USERS_FAILURE, error);

export const postUserRequest = (data: User) => action(UserTypes.POST_USER_REQUEST, data);
export const postUserSuccess = (data: User) => action(UserTypes.POST_USER_SUCCESS, data);
export const postUserFailure = (error: AxiosError) => action(UserTypes.POST_USER_FAILURE, error);
export const postUserClear = () => action(UserTypes.POST_USER_CLEAR);

export const postFeedbackRequest = (data: Feedback) => action(UserTypes.POST_FEEDBACK_REQUEST, data);
export const postFeedbackSuccess = () => action(UserTypes.POST_FEEDBACK_SUCCESS);
export const postFeedbackFailure = (error: AxiosError) => action(UserTypes.POST_FEEDBACK_FAILURE, error);
export const postFeedbackClear = () => action(UserTypes.POST_FEEDBACK_CLEAR);
